export default {
  'app.network.offline': 'আপনি এখন অফলাইন। কিছু বৈশিষ্ট্য অনুপলব্ধ হতে পারে।',
  'app.error.chunk.title': 'পৃষ্ঠা লোড করতে ব্যর্থ',
  'app.error.chunk.description.offline':
    'আপনার নেটওয়ার্ক সংযোগ বিচ্ছিন্ন হয়েছে। আপনার সংযোগ পরীক্ষা করুন এবং পৃষ্ঠাটি রিফ্রেশ করুন।',
  'app.error.chunk.description.online':
    'পৃষ্ঠা সম্পদ লোড করতে ব্যর্থ। দয়া করে রিফ্রেশ করুন এবং আবার চেষ্টা করুন।',
  'app.error.render.title': 'কিছু ভুল হয়েছে',
  'app.error.render.description':
    'দুঃখিত, এই পৃষ্ঠায় একটি ত্রুটি ঘটেছে। দয়া করে রিফ্রেশ করুন বা হোম পৃষ্ঠায় ফিরে যান।',
  'app.error.retry': 'আবার চেষ্টা করুন',
  'app.error.reload': 'পৃষ্ঠা রিফ্রেশ করুন',
  'app.error.home': 'হোমে ফিরে যান',
  'app.request.offline':
    'নেটওয়ার্ক অনুপলব্ধ। আপনার সংযোগ পরীক্ষা করুন এবং আবার চেষ্টা করুন।',
};
